// extracted by mini-css-extract-plugin
export default {"placeHolderContainer":"styles-moduleplaceHolderContainer-3LD7M"};